import { Square } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import { Column, Row } from 'further-ui/components/Layout';

const sections = [
  {
    title: 'For investments',
    bullets: [
      'Name of company/investment (if not disclosed, state the reason)',
      'Description of company/investment, including: geography, industry, use of capital, and the strategy of the deal (for example, was this a buyout, a growth/expansion transaction, a distressed for control deal etc)',
      'Deal parameters, such as anticipated closing date of purchase, other parties involved in the deal, total financing amount (all parties and GP-specific amount), terms of the financing, type of security purchased, total enterprise value of the deal, company TTM EBITDA, debt versus equity used to complete the transaction, transaction expenses and/or fees generated, GP net contributed to the company/investment once closed',
      'Deemed/notional capital contribution amount included in the call (if applicable)',
      'Describe and date any amendments or waivers to the LPA that were needed to facilitate this investment (if applicable)',
    ],
  },
  {
    title: 'For management fees and/or fund expenses',
    bullets: [
      'Expense to be covered, presented in accordance with the categories found in the ILPA’s Reporting Template for fees, expenses and carried interest (which can also be found in the appendix to this document)',
      'Calculation of amount and method',
      'Reduction or offset amounts',
      'Management fee waivers, including any expenses paid to the GP prior to applying the waiver',
      'Whether inside or outside of commitment',
    ],
  },
  {
    title: 'For cash distributions',
    bullets: [
      'Name of company/investment (If not disclosed, state the reason)',
      'Amount and description of distribution (e.g. sale, dividend recap, income, etc.)',
      "For a sale, date of transaction, type of purchaser/buyer, proceeds held in escrow and the fund's potential portion of the escrow, transaction description (total amount, pricing, etc.)",
      'For partially exited investments, the amount distributed to date and the cost basis of the remaining investment',
      "For fully exited investments, the fund investment's total MOIC and gross IRR",
      'Amount of carry accrued and/or paid to the GP (fund level); how much, if any, of the carry is held in escrow?',
      'Aggregate breakdown of ROC/gain/income (fund level)',
    ],
  },
  {
    title: 'For stock distributions',
    bullets: [
      'Name of company/investment',
      'Security Name, Ticker, CUSIP',
      'Shares distributed, historical cost of shares, current value of shares, basis for value, as defined in LPA',
      'Shares distributed to GP in consideration for carried interest distribution and supporting calculation',
      'Settlement location for shares, contact information for settlement location',
      'Restrictions on sale of shares',
    ],
  },
];

const Guidelines = () => {
  return (
    <Column spacing="lg">
      <Typography variant="body2">
        The ILPA guidelines request disclosure of information for each element
        of a capital call or distribution. If you wish to comply with ILPA,
        below are the guidelines as set out in ILPA’s{' '}
        <i>Capital Call & Distribution Notice Best Practices</i> note.
      </Typography>
      {sections.map((section) => (
        <Column spacing="sm" key={section.title}>
          <Typography variant="h6">
            <b>{section.title}</b>
          </Typography>
          {section.bullets.map((bullet) => (
            <Row key={bullet} spacing="lg">
              <Typography variant="body2" color="grey.900">
                <Square
                  sx={(theme) => ({
                    fontSize: '8px',
                    color: theme.palette.grey[900],
                  })}
                  fontSize="inherit"
                />
              </Typography>
              <Typography variant="body2" color="grey.900">
                {bullet}
              </Typography>
            </Row>
          ))}
        </Column>
      ))}
    </Column>
  );
};

export default Guidelines;
